import { actionDuckUtils } from 'wanderu-ducks-utils';

import SLICE_NAMESPACE from '../../../types';

const namespace = 'ACTIONS/FETCH_POLICY';

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, SLICE_NAMESPACE);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
